import React from 'react';
import {
  BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO,
  BondInsuranceHiredDataForGetCompleteBondInsuranceProposalByIdResponseDTO
} from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import { DateToStringDate } from '../../../../../services/date';
import { getBondInsuranceProposalStatusLabel } from '../../../../../services/bond-insurance-proposal';
import { maskMoney } from '../../../../../services/masks';
import { BondInsuranceHiredDataStatusEnum } from '../../../../../enums/bond-insurance-hired-data-status.enum';

export type Props = {
  bondInsuranceAnalysis: BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO;
  hiredData: BondInsuranceHiredDataForGetCompleteBondInsuranceProposalByIdResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsuranceProposalMainInfoDetails = (props: Props) => {
  const { bondInsuranceAnalysis, hiredData } = props;
  const insurer =
    bondInsuranceAnalysis.insurer.name +
    (bondInsuranceAnalysis.selectedPlan
      ? ` (${bondInsuranceAnalysis.selectedPlan?.toUpperCase()})`
      : '');

  return (
    <div className="row" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="ID" value={bondInsuranceAnalysis.id} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DATA DE EMISSÃO DA PROPOSTA"
            value={
              bondInsuranceAnalysis.insurerProposalCreatedAt
                ? DateToStringDate(bondInsuranceAnalysis.insurerProposalCreatedAt)
                : 'Indisponível'
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="SEGURADORA" value={insurer} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="CÓD. DA COTAÇÃO"
            value={bondInsuranceAnalysis.insurerQuotationId}
          />
        </div>
      </div>

      {/* Assistência Contratada (Pottencial) */}
      {hiredData.selectedAssistance && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
            <FieldDisplay
              label="ASSISTÊNCIA CONTRATADA"
              value={hiredData.selectedAssistance.name}
            />
          </div>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay
              label="VALOR DA ASSISTÊNCIA"
              value={
                hiredData.selectedAssistance.monthlyAmount === 0
                  ? 'Incluso gratuitamente'
                  : `R$ ${maskMoney(String(hiredData.selectedAssistance.monthlyAmount), true)}/mês`
              }
            />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="CÓD. DA PROPOSTA"
            value={bondInsuranceAnalysis.insurerProposalId}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="STATUS"
            value={
              getBondInsuranceProposalStatusLabel(
                hiredData.status as BondInsuranceHiredDataStatusEnum
              ) || ''
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="VIGÊNCIA INFORMADA NA ANÁLISE"
            value={bondInsuranceAnalysis.bondInsurance.property.validity}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="PREMIO TOTAL COTADO (R$)"
            value={maskMoney(
              String(
                bondInsuranceAnalysis.value *
                bondInsuranceAnalysis.bondInsurance.property.validity
              ),
              true,
              2
            )}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="INÍCIO VIGÊNCIA CONTRATO LOCAÇÃO"
            value={
              bondInsuranceAnalysis.bondInsurance.property.rental_period_start_date
                ? DateToStringDate(
                  bondInsuranceAnalysis.bondInsurance.property.rental_period_start_date
                )
                : bondInsuranceAnalysis.bondInsurance.property
                  .rent_insurance_contract_start_date
                  ? DateToStringDate(
                    bondInsuranceAnalysis.bondInsurance.property
                      .rent_insurance_contract_start_date
                  )
                  : 'Indisponível'
            }
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="FIM VIGÊNCIA CONTRATO LOCAÇÃO"
            value={
              bondInsuranceAnalysis.bondInsurance.property.rental_period_end_date
                ? DateToStringDate(
                  bondInsuranceAnalysis.bondInsurance.property.rental_period_end_date
                )
                : bondInsuranceAnalysis.bondInsurance.property
                  .rent_insurance_contract_end_date
                  ? DateToStringDate(
                    bondInsuranceAnalysis.bondInsurance.property
                      .rent_insurance_contract_end_date
                  )
                  : 'Indisponível'
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="Início vigência da garantia"
            value={
              bondInsuranceAnalysis.bondInsurance.property
                .rent_insurance_contract_start_date
                ? DateToStringDate(
                  bondInsuranceAnalysis.bondInsurance.property
                    .rent_insurance_contract_start_date
                )
                : bondInsuranceAnalysis.bondInsurance.property.rental_period_start_date
                  ? DateToStringDate(
                    bondInsuranceAnalysis.bondInsurance.property.rental_period_start_date
                  )
                  : 'Indisponível'
            }
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="Fim vigência da garantia"
            value={
              bondInsuranceAnalysis.bondInsurance.property
                .rent_insurance_contract_end_date
                ? DateToStringDate(
                  bondInsuranceAnalysis.bondInsurance.property
                    .rent_insurance_contract_end_date
                )
                : bondInsuranceAnalysis.bondInsurance.property.rental_period_end_date
                  ? DateToStringDate(
                    bondInsuranceAnalysis.bondInsurance.property.rental_period_end_date
                  )
                  : 'Indisponível'
            }
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DIA DE VENCIMENTO DO ALUGUEL"
            value={`${bondInsuranceAnalysis.bondInsurance.property.rent_due_date || 'Indisponível'
              }`}
          />
        </div>
      </div>

      {bondInsuranceAnalysis.observations && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay
              label="Observações análise"
              value={bondInsuranceAnalysis.observations}
            />
          </div>
        </div>
      )}
      {hiredData.observations && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay
              label="Observações Contratação"
              value={hiredData.observations}
            />
          </div>
        </div>
      )}

      {hiredData.nonRenewalReason && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay
              label="Motivo De Não Renovação"
              value={hiredData.nonRenewalReason}
            />
          </div>
        </div>
      )}

      {(bondInsuranceAnalysis.contractor || bondInsuranceAnalysis.updater) && (
        <div style={{ display: 'flex', width: '100%' }}>
          {bondInsuranceAnalysis.updater && (
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay label="EDITADO POR" value={bondInsuranceAnalysis.updater} />
            </div>
          )}
          {bondInsuranceAnalysis.contractor && (
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="CONTRATADO POR"
                value={bondInsuranceAnalysis.contractor}
              />
            </div>
          )}
          {!bondInsuranceAnalysis.updater && bondInsuranceAnalysis.contractor && (
            <div style={{ flex: 1 }}></div>
          )}
          {bondInsuranceAnalysis.updater && !bondInsuranceAnalysis.contractor && (
            <div style={{ flex: 1 }}></div>
          )}
        </div>
      )}
    </div>
  );
};
